var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaleavatar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1082_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1083_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1084_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1085_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1086_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1087_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1088_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1089_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1090_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1091_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1092_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1093_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1094_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1095_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0 59.61-20.38 114.46-54.54 157.97-46.87 59.69-119.69 48.912-201.46 48.912s-154.59 10.778-201.46-48.912c-34.16-43.51-54.54-98.36-54.54-157.97 0-141.38 114.62-256 256-256s256 114.62 256 256z",
    fill: "#5bbc96"
  })))))))))))))))))))), /*#__PURE__*/React.createElement("path", {
    d: "m159.953 215.1 94.783 94.783 40.079 27.512 91.497 120.424c27.423-6.258 51.554-18.895 71.148-43.849 34.16-43.51 54.54-98.36 54.54-157.97 0-3.679-.082-7.339-.236-10.981l-168.564-168.564z",
    fill: "#309167"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m457.46 383.21v30.76c-46.87 59.69-119.69 98.03-201.46 98.03s-154.59-38.34-201.46-98.03v-30.76c0-24.04 19.49-43.53 43.53-43.53h64.36l93.79 29.4 93.79-29.4h63.92c24.04 0 43.53 19.49 43.53 43.53z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m457.46 383.21v30.76c-46.87 59.69-119.69 98.03-201.46 98.03v-142.99l.22.07 93.79-29.4h63.92c24.04 0 43.53 19.49 43.53 43.53z",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.16 425.84v61.45c-11.23-5.33-22-11.46-32.25-18.32v-43.13z",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m398.53 425.84v42.84c-10.25 6.88-21.02 13.04-32.25 18.4v-61.24z",
    fill: "#bfbfbf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 42.357s-128.297-5.056-93.571 112.067l93.571 18.794 93.571-18.795c34.726-117.123-93.571-112.066-93.571-112.066z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m349.57 154.42h-93.57v-112.06s128.3-5.06 93.57 112.06z",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199.97 250.232h112.06v118.84h-112.06z",
    fill: "#eaa678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 250.236h56.03v118.84h-56.03z",
    fill: "#d38c5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.251 152.225c-3.728-56.6-49.511-77.517-88.251-77.517s-84.523 20.917-88.251 77.517c-10.018 1.938-17.134 15.077-16.014 25.701l1.717 24.177c1.175 11.157 10.982 19.301 21.79 18.089l1.864-.202c22.138 59.446 56.857 65.644 78.894 69.125 22.038-3.48 56.756-9.678 78.894-69.125l1.864.202c10.807 1.212 20.614-6.932 21.79-18.089l1.717-24.177c1.12-10.624-5.996-23.763-16.014-25.701z",
    fill: "#ffc397"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.265 177.926-1.717 24.177c-1.175 11.157-10.982 19.301-21.79 18.089l-1.864-.202c-7.566 20.293-16.592 34.388-26.078 44.277-18.291 19.081-38.299 22.552-52.817 24.847v-214.406c38.74 0 84.523 20.917 88.251 77.517 10.019 1.938 17.135 15.077 16.015 25.701z",
    fill: "#eaa678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 65.416s-83.435 5.384-93.571 89.007l14.433 33.19 21.968-60.535 15.486 27.03 20.272-27.03 21.412 27.03 21.412-27.03 20.272 27.03 15.486-27.03 23.336 60.535 13.065-33.189c-10.136-83.623-93.571-89.008-93.571-89.008z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m349.57 154.42-13.06 33.19-12.8-33.19-10.54-27.34-15.49 27.03-20.27-27.03-21.41 27.03v-88.69s83.44 5.38 93.57 89z",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m199.97 309.655-37.541 30.029 46.785 57.438 46.786-28.047z",
    fill: "#336b90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m312.117 309.655 37.542 30.029-46.786 57.438-46.786-28.047z",
    fill: "#163c66"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleavatar2);
export default __webpack_public_path__ + "static/media/Maleavatar_2.3e79b31a19aa31792e137b4d8fdc5bb8.svg";
export { ForwardRef as ReactComponent };